<template>
    <span>
        <v-icon v-if="filePath || filePath2 || filePath3 || filePath4 || filePath5" color="green" @click="openDialog">mdi-image</v-icon>
        <v-dialog
                v-model="dialog"
                max-width="100%"
                scrollable
        >
            <v-card>
                <v-card-title class="headline">
                    시안확인
                    <v-spacer></v-spacer>
                    <div class="d-none d-md-flex">
                        <span style="float:right" class="mr-5">{{ imageWidth }}%</span>
                        <v-btn fab small color="primary" style="float:right" class="mr-3" @click="imagePlus">
                            <v-icon color="white">mdi-plus</v-icon>
                        </v-btn>
                        <v-btn fab small color="primary" style="float:right" @click="imageMinus">
                            <v-icon color="white">mdi-minus</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>

                <v-card-text>
                    <div class="text-center mt-0 text-sm-h6 text-md-h5">
                        주문상세내역 : {{ description }}
                    </div>
                    <div v-if="isClient && buttonFlag" class="text-center mt-5 mb-8">
                        <v-btn color="primary" @click="okDialog = true">시안 확인 완료</v-btn>
                        <v-btn color="grey" class="ml-5" @click="requestDialog = true">시안 수정 요청</v-btn>
                        <v-row justify="center">
                            <v-dialog
                                    persistent
                                    v-model="okDialog"
                                    max-width="320"
                                    @keydown.esc="okDialog = false"
                                    @keydown.enter="setStatusOk"
                            >
                                <v-card>
                                    <v-card-title class="headline">시안 확인 완료</v-card-title>
                                    <v-card-text>
                                        시안 확인 완료 시 바로 인쇄 작업에 들어가며
                                        <br />
                                        오타 및 기타 오류 발생 시 되돌릴 수 없습니다.
                                        <br />
                                        정말 완료 처리 하시겠습니까?
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                color="green darken-1"
                                                text
                                                @click="okDialog = false"
                                        >취소</v-btn>

                                        <v-btn
                                                color="green darken-1"
                                                text
                                                @click="setStatusOk"
                                        >확인</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-row>
                        <v-row justify="center">
                            <v-dialog
                                    persistent
                                    v-model="requestDialog"
                                    max-width="320"
                                    @keydown.esc="requestDialog = false"
                                    @keydown.enter="setStatusRequest"
                            >
                                <v-card>
                                    <v-card-title class="headline">시안 수정 요청</v-card-title>
                                    <v-card-text>
                                        시안 수정 요청사항은 아래의 메일로
                                        <br />
                                        보내주시기 바랍니다.
                                        <br /><br />
                                        <strong class="heading">bspojang@naver.com</strong>
                                        <br /><br />
                                        확인 버튼 클릭 시 수정 요청이 진행됩니다.
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                color="green darken-1"
                                                text
                                                @click="requestDialog = false"
                                        >취소</v-btn>

                                        <v-btn
                                                color="green darken-1"
                                                text
                                                @click="setStatusRequest"
                                        >확인</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-row>
                    </div>
                    <div v-if="!buttonFlag" class="text-center mt-5 mb-8">
                        {{ waitingText }}
                    </div>
                    <v-img :aspect-ratio="16/9"
                           contain class="mx-auto"
                           :width="imageWidth + '%'"
                           max-width="300%"
                           :src="filePath" v-if="filePath"
                           @click="!isClient && downloadImage(filePath)"></v-img>
                    <v-img :aspect-ratio="16/9"
                           contain class="mx-auto"
                           :width="imageWidth + '%'"
                           max-width="300%"
                           :src="filePath2" v-if="filePath2"
                           @click="!isClient && downloadImage(filePath2)"></v-img>
                    <v-img :aspect-ratio="16/9"
                           contain class="mx-auto"
                           :width="imageWidth + '%'"
                           max-width="300%"
                           :src="filePath3" v-if="filePath3"
                           @click="!isClient && downloadImage(filePath3)"></v-img>
                    <v-img :aspect-ratio="16/9"
                           contain class="mx-auto"
                           :width="imageWidth + '%'"
                           max-width="300%"
                           :src="filePath4" v-if="filePath4"
                           @click="!isClient && downloadImage(filePath4)"></v-img>
                    <v-img :aspect-ratio="16/9"
                           contain class="mx-auto"
                           :width="imageWidth + '%'"
                           max-width="300%"
                           :src="filePath5" v-if="filePath5"
                           @click="!isClient && downloadImage(filePath5)"></v-img>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="green darken-1"
                            text
                            @click="closeDialog"
                    >
                        닫기
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
import axios from "axios";

export default {
    name: 'HasDraftImageButton',
    props: {
        orderId: {},
        filePath: {},
        filePath2: {},
        filePath3: {},
        filePath4: {},
        filePath5: {},
        description: {},
        refreshOrders: {},
        isClient: {}
    },
    data() {
        return {
            dialog: false,
            okDialog: false,
            requestDialog: false,
            buttonFlag: false,
            waitingText: null,
            imageWidth: '100',
        }
    },
    methods: {
        getDesignStatus: async function() {

            if(!this.$route.params.clientCode){
              return false
            }

            if(!this.filePath && !this.filePath2 && !this.filePath3 && !this.filePath4 && !this.filePath5){
                return false
            }

            const clientInfo = this.$store.getters.getClientInfo
            const clientPhone = clientInfo.clientPhone

            return axios({
                method: 'POST',
                url: this.$store.getters.getApiUrl + '/api/v1/client/getDesignStatus/' + this.$route.params.clientCode + '/' + this.orderId,
                data: {
                  clientPhone: clientPhone
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null && response.data.status == '0000'){

                    const designStatus = response.data.designStatus
                    this.changeWaitingText(designStatus)

                }

            })

        },
        setStatusOk: function() {
            this.updateDesignStatus('고객확인완료')
        },
        setStatusRequest: function() {
            this.updateDesignStatus('시안수정요청')
        },
        updateDesignStatus: function(designStatus) {

            if(!this.filePath){
                return false
            }

            const clientInfo = this.$store.getters.getClientInfo
            const clientPhone = clientInfo.clientPhone

            return axios({
                method: 'POST',
                url: this.$store.getters.getApiUrl + '/api/v1/client/updateDesignStatus/' + this.$route.params.clientCode + '/' + this.orderId,
                data: {
                    clientPhone: clientPhone,
                    designStatus: designStatus
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null && response.data.status == '0000'){

                    this.changeWaitingText(response.data.designStatus)
                    this.refreshOrders()

                    alert(response.data.message)

                    location.reload()

                }else{

                    alert(response.data.message)
                    return false

                }

            })

        },
        changeWaitingText(designStatus) {

            if(designStatus == '시안확인중') {
                this.buttonFlag = true
            }else{

                this.buttonFlag = false

                if(designStatus == '시안수정요청'){
                    this.waitingText = '현재 수정 요청 상태입니다. 시안 등록 시 알림톡으로 안내 해드립니다.'
                }else if(designStatus == '고객확인완료'){
                    this.waitingText = '시안을 확인 완료 했습니다. 방산 포장에서 다시 한 번 확인중입니다.'
                }else if(designStatus == '방산확인완료'){
                    this.waitingText = '고객님은 본 시안을 확정하셨습니다.'
                }

            }

        },
        imagePlus: function() {
            if(this.imageWidth >= 300){
                return false
            }
            this.imageWidth = parseInt(this.imageWidth) + 10
        },
        imageMinus: function() {
            if(this.imageWidth <= 50){
                return false
            }
            this.imageWidth = parseInt(this.imageWidth) - 10
        },
        openDialog: function() {
            this.imageWidth = 100
            this.dialog = true
            if(this.isClient){
                this.$router.push('/client/dashboard/' + this.$route.params.clientCode + '/' + this.orderId)
            }
        },
        closeDialog: function() {
            this.dialog = false
            if(this.isClient){
                this.$router.push('/client/dashboard/' + this.$route.params.clientCode)
            }
        },
        downloadImage: function(imageUrl) {
            if(confirm('이미지를 다운로드 하시겠습니까?')){
                window.open(imageUrl)
            }
        }
    },
    created: async function() {
      if (this.filePath != null) {
        await this.getDesignStatus()
      }

      if (this.isClient && this.filePath && this.orderId == this.$route.params.orderId) {
        this.dialog = true
      }
    }
}
</script>